export interface FrameStatsSnapshot {
  /** Images par seconde sur la fenêtre (0 si inconnu). */
  readonly fps: number;
  /** Durée moyenne de traitement par image (ms). */
  readonly avgMs: number;
}

export interface FrameStats {
  record(t: number, durationMs: number): void;
  get(): FrameStatsSnapshot;
}

/** Cadence et coût de traitement sur une fenêtre glissante de `windowMs`. */
export function createFrameStats(windowMs = 1000): FrameStats {
  let entries: { t: number; ms: number }[] = [];
  return {
    record(t, durationMs) {
      entries.push({ t, ms: durationMs });
      entries = entries.filter((e) => e.t >= t - windowMs);
    },
    get() {
      const first = entries[0];
      const last = entries.at(-1);
      if (!first || !last) return { fps: 0, avgMs: 0 };
      const span = last.t - first.t;
      const fps = span > 0 ? ((entries.length - 1) * 1000) / span : 0;
      const avgMs = entries.reduce((sum, e) => sum + e.ms, 0) / entries.length;
      return { fps, avgMs };
    },
  };
}
